export type Question = {
  question: string
  answer: string
}

const QUESTIONS: Question[] = [
  {
    question: 'Do you offer discounts?',
    answer: 'Yes. When you pay for a year up front, you get 2 months of Propelio free. We are always running specials so feel free to ask us what is available.',
  },
  {
    question: 'Does Propelio offer a free trial?',
    answer: 'We do not have a free trial; we have a free plan and paid plans. The free plan is identical to the paid, but with fewer consumables.',
  },
  {
    question: 'Can we cancel at any time?',
    answer: 'There\'s no minimum contract for Propelio - cancel at any time without penalty or hassle. If you prepaid for a year, we\'ll refund any unused months.',
  },
  {
    question: 'What if I have more questions?',
    answer: 'We\'d be happy to answer them. Just click the chat bubble in the bottom right corner of the screen.',
  },
]

export const useCommonQuestions = (): Question[] => QUESTIONS
